import withNavigationTheme from '../../hooks/withNavigationTheme';
import TopNavigationSidebarDrawerWithHeader from './TopNavigationSidebarDrawerWithHeader';

export default withNavigationTheme(TopNavigationSidebarDrawerWithHeader);
